import React from "react";
import "./About.css";

const About: React.FC = () => {
  return (
    <section className="about-page">
      <div className="about-container">
        <h1>About</h1>
        <p className="subtitle">
          Helping South Africans make smarter money decisions.
        </p>

        <div className="about-section">
          <h2>Our intention</h2>
          <p>
            The goal of Totties is to turn complex money questions into clear,
            practical guidance. We bring together reliable, up‑to‑date
            information and purpose‑built calculators so consumers and lenders
            can make smarter, more confident decisions.
          </p>
          <p>
            Everything here is free to use. We prioritise accuracy, transparency
            and simplicity over jargon — so you can focus on the choices that
            matter.
          </p>
          <p>
            If you find this tool useful, please consider supporting me by
            buying me a coffee.
          </p>
          <a
            href="https://www.buymeacoffee.com/totties"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
              alt="Buy Me a Coffee"
              style={{ height: "41px" }}
            />
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
